import { render, staticRenderFns } from "./takeMoney.vue?vue&type=template&id=0a95665e&scoped=true&"
import script from "./takeMoney.vue?vue&type=script&lang=js&"
export * from "./takeMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95665e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a95665e')) {
      api.createRecord('0a95665e', component.options)
    } else {
      api.reload('0a95665e', component.options)
    }
    module.hot.accept("./takeMoney.vue?vue&type=template&id=0a95665e&scoped=true&", function () {
      api.rerender('0a95665e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/balanceCompany/company/takeMoney.vue"
export default component.exports